import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4103f0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lg:min-h-screen pt-10 lg:pt-3 lg:-mt-12" }
const _hoisted_2 = { class: "flex flex-col lg:flex-row lg:mb-20 text-left w-3/4 mx-auto lg:h-screen lg:-mt-10" }
const _hoisted_3 = { class: "flex-1 flex flex-col justify-center space-y-9 lg:pr-8" }
const _hoisted_4 = {
  class: "lg:h-auto flex flex-col justify-around lg:justify-center lg:pb-0 space-y-8 lg:py-12 lg:py-0",
  id: "home-title-image-subtitle"
}
const _hoisted_5 = { class: "flex-1 lg:flex-shrink flex items-center" }
const _hoisted_6 = { class: "flex-1 lg:flex-shrink font-display text-5xl lg:text-8xl lg:pb-0 text-palette5 font-bold opacity-80 text-right lg:text-left" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" flashi ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-1 lg:flex-shrink lg:pt-3 text-xl lg:text-3xl flex flex-col justify-center lg:space-y-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-palette2 italic" }, [
    /*#__PURE__*/_createTextVNode(" Create vocabulary "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("flashcards faster! ")
  ])
], -1))
const _hoisted_9 = { class: "" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Learning a language?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Trying to memorize new vocabulary?")
], -1))
const _hoisted_11 = { class: "pt-3" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Create flashcards faster with ")
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" automated translation and image search. ")
const _hoisted_15 = { class: "pt-3" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Keep the vocabulary in long term memory")
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" with smart scheduler. ")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pt-3" }, " Add vocabulary directly in the browser with free Chrome Extension! ", -1))
const _hoisted_20 = { class: "mr-auto" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("get started ")

import { defineProps, defineEmits } from "@vue/runtime-core";
import MyButton from "../../components/MyButton.vue";
import HomePageTopImage from "../HomePage/HomePageTopImage.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  isMobile: Boolean,
},
  emits: ["getStarted"],
  setup(__props, { emit }) {




return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, [
              _createVNode(_component_font_awesome_icon, { icon: "bolt" }),
              _hoisted_7
            ])
          ]),
          (__props.isMobile)
            ? (_openBlock(), _createBlock(HomePageTopImage, {
                key: 0,
                class: "flex-1 lg:flex-shrink"
              }))
            : _createCommentVNode("", true),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("p", _hoisted_11, [
            _hoisted_12,
            (!__props.isMobile)
              ? (_openBlock(), _createElementBlock("br", _hoisted_13))
              : _createCommentVNode("", true),
            _hoisted_14
          ]),
          _createElementVNode("p", _hoisted_15, [
            _hoisted_16,
            (!__props.isMobile)
              ? (_openBlock(), _createElementBlock("br", _hoisted_17))
              : _createCommentVNode("", true),
            _hoisted_18
          ]),
          _hoisted_19
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(MyButton, {
            class: "px-6",
            onClickButton: _cache[0] || (_cache[0] = ($event: any) => (emit('getStarted')))
          }, {
            default: _withCtx(() => [
              _hoisted_21,
              _createVNode(_component_font_awesome_icon, {
                icon: "globe-americas",
                class: "ml-3"
              })
            ]),
            _: 1
          })
        ])
      ]),
      (!__props.isMobile)
        ? (_openBlock(), _createBlock(HomePageTopImage, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})